module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-center box-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          優惠券折抵規則\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.newCouponType.label))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("折抵策略名稱")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.name))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("折抵描述")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.description))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.newCouponType) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-left box-body"
  }, [(_vm.ruleCode === 'SC00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("滿足商品金額 (買X元，送優惠券)")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.setting.money_unit))])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.ruleCode === 'SC00001') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品限制最低單價")]), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.setting.lowest_unit_price) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.setting.lowest_unit_price) + " 元")]) : _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v("無設定")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("一次最大使用張數")]), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.setting.one_max_amount) ? _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.setting.one_max_amount) + " 張")]) : _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v("無設定")])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.newCouponType) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-left box-body"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低購買數")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.limit.min_amount) + " 個")])]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.limit.order_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            訂單類型\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.giveCoupons.coupon_strategy.limit.order_types), function(ot) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(ot.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.limit.order_method.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            訂單方案\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.giveCoupons.coupon_strategy.limit.order_method), function(om) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(om.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-right box-body"
  }, [(_vm.giveCoupons.coupon_strategy.limit.delivery_types.length) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            取貨方式\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, _vm._l((_vm.giveCoupons.coupon_strategy.limit.delivery_types), function(dt) {
    return _c('label', {
      staticClass: "label-success label m-r-5"
    }, [_vm._v(_vm._s(dt.label))])
  }), 0)]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.limit.min_money) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低總金額")]), _vm._v(" "), _c('span', {
    staticClass: "form-control form-info"
  }, [_vm._v(_vm._s(_vm.giveCoupons.coupon_strategy.limit.min_money) + " 元")])]), _vm._v(" "), _c('br')]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.store_exception_items[0].products.length || _vm.giveCoupons.coupon_strategy.setting.vendor_custom_product_list.length) ? _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.ruleCode === 'SC00001' || _vm.ruleCode === 'SC00003') ? _c('h5', [_vm._v("例外商品選擇")]) : _c('h5', [_vm._v("指定商品選擇")])]), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.store_exception_items[0].products.length && (_vm.ruleCode === 'SC00001' || _vm.ruleCode === 'SC00003')) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.giveCoupons.coupon_strategy.store_exception_items[0].products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.setting.vendor_custom_product_list.length && _vm.ruleCode === 'SC00002') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.giveCoupons.coupon_strategy.setting.vendor_custom_product_list), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])])])
  }), 0)])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('h4', [_vm._v("使用規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('h4', [_vm._v("限制規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a817cdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Marketing/Temp/CouponStrategyInfo.vue
// module id = 2383
// module chunks = 1